/**
 * Ended Experience Notification Service
 *
 * Fetch API implementation for ended experience notifications by user.
 */

const API_SERVER = process.env.API_SERVER || '';

export class EndedExperienceNotificationService {
  static async getEndedExperiences(userId: number): Promise<unknown[]> {
    if (userId <= 0) {
      throw new Error('userId must be a positive number');
    }
    const url = `${API_SERVER}/notifications/users/${userId}/type/experience_ended`;

    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch ended experience notifications: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : [];
  }

  static async removeEndedExperiences(userId: number): Promise<void> {
    if (userId <= 0) {
      throw new Error('userId must be a positive number');
    }
    const url = `${API_SERVER}/notifications/users/${userId}/type/experience_ended`;

    const response = await fetch(url, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to remove ended experience notifications: ${response.status} ${response.statusText}`);
    }
  }
}

export default EndedExperienceNotificationService;
